<template>
  <div class="chart-wrapper">
    <apexchart type="radialBar" height="320" :options="chartOptions" :series="series" class="elsa-chart" />
  </div>
</template>

<script>
  export default {
    props: {
      series: {
        type: Array,
        default: () => [],
      },
    },
    computed: {
      chartOptions() {
        return {
          chart: {
           height: 260,
           type: "radialBar",
          },
          plotOptions: {
            radialBar: {
              startAngle: -135,
              endAngle: 135,
              hollow: {
                size: "70%",
              },
              dataLabels: {
                name: {
                  offsetY: 25,
                  color: "#121131",
                  lineHeight: "20px",
                  fontWeight: "500",
                  fontStyle: "normal",
                  opacity: 0.7, 
                  fontFamily: "SF Pro Display",
                },
                value: {
                    formatter: function(val) {
                      return (val/10).toFixed(1);
                    },
                  offsetY: -30,
                  color: "#121131",
                  fontSize: "30px",
                  lineHeight: "36px",
                  fontWeight: "bold",
                  fontStyle: "normal",
                  fontFamily: "SF Pro Display",
                },
              },
            },
          },
          fill: {
            type: "gradient",
            gradient: {
              shade: "dark",
              type: "vertical",
              shadeIntensity: 0.4,
              gradientToColors: ["#29F4FF","#5257FF"],
              inverseColors: true,
              opacityFrom: 1,
              opacityTo: 1,
              stops: [20, 90],
            },
          },
          stroke: {
            lineCap: "round",
          },
          labels: [this.range],
        };
      },
      range() {
        const score = this.series[0];
        let range;
        if (score == 0) {
          range = this.$t("charts.ielts_score.no_data");
        } else if (score <= 10) {
          range = this.$t("charts.ielts_score.very_poor");
        } else if (score <= 20) {
          range = this.$t("charts.ielts_score.intermittent");
        } else if (score <= 30) {
          range = this.$t("charts.ielts_score.extremely_limited");
        } else if (score <= 40) {
          range = this.$t("charts.ielts_score.limited");
        } else if (score <= 50) {
          range = this.$t("charts.ielts_score.modest");
        } else if (score <= 60) {
          range = this.$t("charts.ielts_score.competent");
        } else if (score <= 70) {
          range = this.$t("charts.ielts_score.good");
        } else if (score <= 80) {
          range = this.$t("charts.ielts_score.very_good");
        } else {
          range = this.$t("charts.ielts_score.expert");
        }
        return range;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .chart-wrapper {
    height: 350px;
    display: flex;
    flex-direction: column;

    .elsa-chart {
      margin-top: auto;
      margin-bottom: auto;
    }
  }
</style>
